import React from 'react';
import '../../shared/LibraryTheme.scss';
import lightThemeImage from '../../assets/light-bulp.svg';
import darkThemeImage from '../../assets/dark-bulp.svg';
import TimerComponent from '../TimerComponent/TimerComponent';
import { handleNegativeScenario } from '../../shared/shared-utility';

interface ISlideshowFirstPageProps {
  screenOption: string;
  timer: number;
  theme: string;
  overallReductionPercentage: number;
}

const SlideshowFirstPage = (props: ISlideshowFirstPageProps) => {
  let firstColumnClass, reductionPercentageIBO;
  let screenOption = props.screenOption.toLowerCase();
  let theme = props.theme.toLowerCase();
  let themeImage;
  if (screenOption === 'landscape') {
    reductionPercentageIBO = 'first-page-container';
    firstColumnClass = 'percentage-text-area';
  } else {
    reductionPercentageIBO = 'first-page-container ds-portrait-container';
    firstColumnClass = 'percentage-text-area portrait-percentage-text-area';
  }
  if (theme === 'dark') {
    themeImage = darkThemeImage;
  } else {
    themeImage = lightThemeImage;
  }
  return (
    <div className={reductionPercentageIBO}>
      <TimerComponent />
      <div className={firstColumnClass}>
        <div className="first-section">
          <div className="first-section-heading">
            Since using Honeywell Forge Sustainability+ for Buildings, 
            this building has achieved an average daily reduction of
          </div>
          <div className="first-section-percentage">
            {handleNegativeScenario(props.overallReductionPercentage)}%
          </div>
          <div className="first-section-heading">
            in energy consumption and carbon emissions*
          </div>
        </div>
        <div className="second-section">
        
        </div>
        <div className="image-area">
          <img src={themeImage} className="bulp-img"></img>
        </div>
      </div>
    </div>
  );
};

export default SlideshowFirstPage;
